import paramsList from './params-list';
import { Params } from './types';
import { doBasicCheck, ValidationResult } from '../../validator/shared';

export default (params: Params): ValidationResult => {
    if (!doBasicCheck(params, paramsList).isValid) {
        return doBasicCheck(params, paramsList);
    }

    return {
        isValid: true,
    };
};
